
<template>
  <VirtualList
    :list="list"
    :dataComponent="dataComponent"
    @getData="getData"
    :finished="finished"
  />
</template>

<script>
import VirtualList from "@/components/VirtualList";
import dataComponent from "./InSaleItem";
import { getStoreOrderList } from "../webApi";
import { validPhone, validBackstageOrderNo } from "@/utils/vaildate";
export default {
  components: { VirtualList },
  props: ["tabType", "searchValue"],
  created() {
    console.log(this.tabType);
  },
  data() {
    return {
      types: [null, "INITIAL", "PAID", "SHIPPED", "COMPLETED", "CLOSED"],
      list: [],
      dataComponent,
      page: 0,
      size: 10,
      finished: false,
    };
  },
  methods: {
    getData() {
      // debugger;
      if (this.finished) return;
      let params = {
        page: this.page,
        size: this.size,
        state: this.types[this.tabType],
      };

      if (this.searchValue) {
        if (validPhone(this.searchValue)) {
          params.recipientsMobile = this.searchValue;
        } else if (validBackstageOrderNo(this.searchValue)) {
          params.orderNo = this.searchValue;
        } else {
          params.addressee = this.searchValue;
        }
      }
      this.getStoreOrderList(params);
    },

    getStoreOrderList(params) {
      getStoreOrderList(params).then(({ data }) => {
        this.list.push(...data.content);
        if (data.content.length < this.size) {
          this.finished = true;
        } else {
          this.page++;
        }
      });
    },
  },
};
</script>

<style>
</style>
